module.exports = __webpack_public_path__ + "img/WechatIMG1.b9477057.png";